import { useEffect, useState, useRef } from 'react'

import Map from 'ol/Map'
import { transform } from 'ol/proj'
import GeoJSON from 'ol/format/GeoJSON'
import View from 'ol/View'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { Fill, Style, Text, Icon } from 'ol/style'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import Cluster from 'ol/source/Cluster.js'
import { Geometry } from 'ol/geom'

import { style } from './ol-styles'

import kyrgyzstan from './kg.json'

import {
  MapContainer,
  Popup,
  MapHeader,
  MapTitle,
  MapDescription,
  MapSource,
} from './styled'

import {
  MAP_ZOOM,
  MAP_ZOOM_MOBILE,
  MAP_CENTER,
  COLOR_SEA,
  COLOR_LAND,
  BlueMarker,
  info,
  kyrgyzstanExtent3857,
} from './config'

const MAP_CENTER_TRANS = transform(MAP_CENTER, 'EPSG:4326', 'EPSG:3857')

var mapSourceData = {
  type: 'FeatureCollection',
  features: kyrgyzstan.features,
}
var mapSource = new VectorSource({
  features: new GeoJSON({
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:3857',
  }).readFeatures(mapSourceData),
})

/*const shadowStyle = new Style({
  stroke: new Stroke({
    color: 'rgba(0,0,0,0.5)',
    width: 6,
  }),
  zIndex: 0,
})*/
const markers: Feature<Point>[] = []

info.map((city, index) =>
  markers.push(
    new Feature({
      type: 'icon',
      id: index,
      geometry: new Point(
        transform([city.lng, city.lat], 'EPSG:4326', 'EPSG:3857')
      ),
    })
  )
)
const styleCache: { [key: number]: Style } = {}
const clusterSource = new Cluster({
  distance: 30,
  source: new VectorSource({
    features: markers,
  }),
})

const OpenLayers = () => {
  const refMap = useRef<HTMLDivElement>(null)
  const [popupActive, setPopupActive] = useState(false)
  const [place, setPlace] = useState(info[0])
  const showPopup = () => {
    setPopupActive(true)
  }

  useEffect(() => {
    let map = new Map({
      layers: [
        new VectorLayer({
          source: mapSource,
          style: function (feature) {
            style.getFill()?.setColor(COLOR_LAND)
            /*style.getText()?.setText(featureName)*/
            return style
          },
        }),

        new VectorLayer({
          source: clusterSource,
          style: (feature) => {
            const features = feature.get('features')
            const size = features.length
            if (!styleCache[size]) {
              styleCache[size] = new Style({
                image: new Icon({
                  anchor: [0.5, 1],
                  src: BlueMarker,
                }),
                text: new Text({
                  text: size.toString(),
                  font: 'bold 12px sans-serif',
                  offsetY: -32,
                  fill: new Fill({
                    color: '#000',
                  }),
                }),
              })
            }
            return styleCache[size]
          },
        }),
      ],
      view: new View({
        center: MAP_CENTER_TRANS,
        zoom: window.innerWidth < 520 ? MAP_ZOOM_MOBILE : MAP_ZOOM,
        minZoom: 6,
        extent: kyrgyzstanExtent3857,
      }),
    })
    map.on('pointermove', function (evt) {
      if (evt.dragging) {
        return
      }
      var map = evt.map
      var pixel = map.getEventPixel(evt.originalEvent)
      var hit = map.forEachFeatureAtPixel(pixel, function (feature, layer) {
        if (feature && feature.get('type') === 'icon') {
          return true
        } else {
          return false
        }
      })
      map.getTargetElement().style.cursor = hit ? 'pointer' : ''
    })
    map.on('singleclick', function (evt) {
      if (evt.dragging) {
        return
      }
      var map = evt.map
      var pixel = map.getEventPixel(evt.originalEvent)
      map.forEachFeatureAtPixel(pixel, function (feature, layer) {
        const clusteredFeatures = feature.get('features') as
          | Feature<Geometry>[]
          | undefined

        if (!clusteredFeatures) return false
        if (clusteredFeatures.length === 1) {
          // Single feature - get its ID
          const singleFeature = clusteredFeatures[0]
          const id = singleFeature.get('id') // or singleFeature.get('yourCustomId')
          console.log('Clicked feature ID:', id)
          if (typeof id === 'number') {
            const place = info.find((place) => place.id === id)
            if (place) {
              setPlace(place)
              showPopup()
            }
          }
        } else {
          // Cluster - list all IDs
          const ids = clusteredFeatures
            .map((f: Feature<Geometry>) => f.get('id'))
            .filter((id): id is number => typeof id === 'number')
          if (ids.length > 0) {
            const place = info.find((place) => place.id === ids[0])
            if (place) {
              setPlace(place)
              showPopup()
            }
          }
        }
        return true
      })
    })
    map.setTarget('mapContainer')
    return () => {
      map.setTarget(undefined)
    }
  }, [])

  return (
    <>
      <MapContainer>
        <MapHeader>
          <MapTitle>
            Где найти помощь женщинам, пострадавшим от насилия
          </MapTitle>
          <MapDescription>
            Карта кризисных центров Кыргызстана с контактной информацией
          </MapDescription>
        </MapHeader>
        <div
          id="mapContainer"
          ref={refMap}
          className="map-container"
          style={{ background: COLOR_SEA }}
        />
        <Popup $popupActive={popupActive}>
          Кризисный центр {place.city}, Номер телефона: {place.phone}
          <button onClick={() => setPopupActive(false)}>×</button>
        </Popup>
        <MapSource>
          Карта: Чынаргүл Жумабекова • Источник:{' '}
          <a
            href="https://mlsp.gov.kg/ru/telefony-i-kontakty-krizisnyh-czentrov/"
            target="_blank"
            rel="noreferrer"
          >
            ​Министерство труда, социального обеспечения и миграции КР
          </a>
        </MapSource>
      </MapContainer>
    </>
  )
}
export default OpenLayers
